import { AddressResponse, MediaResponse, AuthorResponse } from "./common";

export enum AdStatus {
  WAITING = "WAITING", // Ожидает подтверждения
  CONFIRMED = "CONFIRMED", // Подтверждено
  REJECTED = "REJECTED", // Отклонено
  EXPIRED = "EXPIRED", // Истек срок размещения
  CLOSED = "CLOSED", // Закрыто
}

export function getAdStatusText(status: AdStatus): string {
  switch (status) {
    case AdStatus.WAITING:
      return "Ожидает подтверждения";
    case AdStatus.CONFIRMED:
      return "Активно";
    case AdStatus.REJECTED:
      return "Отклонено";
    case AdStatus.EXPIRED:
      return "Истек срок размещения";
    case AdStatus.CLOSED:
      return "Закрыто";
    default:
      return "Неизвестный статус";
  }
}

export function isActiveAdStatus(status: AdStatus): boolean {
  switch (status) {
    case AdStatus.WAITING:
    case AdStatus.CONFIRMED:
      return true;
    default:
      return false;
  }
}

export enum FieldType {
  STRING = "STRING",
  INT = "INT",
  FLOAT = "FLOAT",
  BOOL = "BOOL",
  DATETIME = "DATETIME",
  TIME = "TIME",
  CHECKBOX = "CHECKBOX",
  FOREIGN_KEY = "FOREIGN_KEY",
  LIST = "LIST",
  DROPDOWN = "DROPDOWN",
  GROUP = "GROUP",
}

export interface CurrencyResponse {
  id: string;
  createdAt: string;
  titleOrigin: string;
  titleEnd: string;
  isoCode: string;
  symbol: string;
}

export interface CategoryResponse {
  id: string;
  title: string;
  description: string;
  image: object;
}

export interface CatalogOptionResponse {
  id: string;
  parentId: string;
  catalogId: string;
  fieldType: FieldType;
  formNames: string[] | null;
  baseOptionId: string | null;
  fieldName: string;
  defaultValue: string | null;
  isRequired: boolean;
  isRange: boolean;
  isMultiple: boolean;
  order: number;
  title: string;
  placeholder: string;
  isSelected: boolean;
  value: string;
  children: CatalogOptionResponse[];
}

export interface CatalogResponse {
  id: string;
  categoryId: string;
  title: string;
  description: string;
  options: CatalogOptionResponse[];
}

export interface AdsResponse {
  id: string;
  number: number;
  createdAt: string;
  publishedAt: string;
  title: string;
  description: string;
  status: AdStatus;
  isHidden: boolean;
  price?: number;
  priceMin?: number;
  priceMax?: number;
  priceDay?: number;
  priceMonth?: number;
  languageIso: string;
  isViewed: boolean;
  user?: AuthorResponse;
  currency?: CurrencyResponse;
  category?: CategoryResponse;
  catalog?: CatalogResponse;
  todayViewsCount: number;
  viewsCount: number;
  repliesCount: number;
  favouritesCount: number;
  commentsCount: number;
  adminCommentsCount: number;
  hasAdminComments: boolean;
  likesCount: number;
  address?: AddressResponse;
  media?: MediaResponse[];
}

// Request
export type AdsSortField =
  | "username"
  | "category"
  | "catalog"
  | "created_at"
  | "price";

export enum AdsListStatus {
  ACTIVE = "ACTIVE",
  ARCHIVED = "ARCHIVED",
}

export interface AdsListRequest {
  search?: string;
  isActive?: boolean;
  sort?: string;
  ordering?: string;
  limit?: number;
  offset?: number;
  status?: AdsListStatus;
  createdFrom?: string; // ISO8601 datetime
  createdTo?: string; // ISO8601 datetime
  priceFrom?: number;
  priceTo?: number;
  userId?: string;
  categoryId?: string;
  catalogId?: string;
}

export interface AdsBlockedRequest {
  limit: number;
  offset: number;
  sort?: string;
  ordering?: string;
  categoryId?: string;
  catalogId?: string;
}

export type AdsType = "posted" | "requiresConfirmation" | "archive";
